import AbstractAction from 'utils/AbstractAction'

class Action extends AbstractAction {
  _namespace = 'General'
}

const showGeneralModal = new Action('showGeneralModal', {
  success: (data) => data,
})

const hideGeneralModal = new Action('hideGeneralModal', {
  success: () => {},
})

const initApp = new Action('initApp', {
  init: (callback) => ({ callback }),
  success: () => ({}),
  failure: () => ({}),
})

const setRegion = new Action('setRegion', {
  success: (region) => ({ region }),
  failure: (responseJson, isNoInternetError) => ({ responseJson, isNoInternetError }),
})

const setIsAuthenticatedRoute = new Action('setIsAuthenticatedRoute', {
  success: (isAuthenticatedRoute) => ({ isAuthenticatedRoute }),
})

const setIpAddress = new Action('setIpAddress', {
  init: () => ({}),
  success: (ipAddress) => ({ ipAddress }),
  failure: (error) => ({ error }),
})

const fetchSecureConstants = new Action('fetchSecureConstants', {
  init: () => ({}),
  success: (payload) => payload,
  failure: (error) => ({ error }),
})

const fetchConstants = new Action('fetchConstants', {
  init: () => ({}),
  success: (payload) => payload,
  failure: (error) => ({ error }),
})

const fetchIntercomUserHash = new Action('fetchIntercomUserHash', {
  init: (callback) => ({ callback }),
  success: (data) => data,
})

export default {
  showGeneralModal,
  hideGeneralModal,
  initApp,
  setRegion,
  setIsAuthenticatedRoute,
  setIpAddress,
  fetchSecureConstants,
  fetchConstants,
  fetchIntercomUserHash,
}
